import React from "react";
import { useSelector } from "react-redux";
import { NavLink, useLocation, useNavigate, Link } from "react-router-dom";
import { Image, Menu, Dropdown } from "semantic-ui-react";
import { signOutFirebase } from "../../app/firestore/firebaseService";
import { partyIsTitleCompany } from "../../app/common/util/util";

export default function NavBarPartyAll() {
  const location = useLocation();
  const navigate = useNavigate();
  const { authenticated } = useSelector((state) => state.auth);
  const { currentUserProfile } = useSelector((state) => state.profile);
  const { partiesForUser } = useSelector((state) => state.party);

  // The Dashboard is only relevant to title company users (and their
  // assistant, who logs in via the same party record - see
  // fetchPartiesForUserFromDb's assistant.email match).
  const isTitleCompanyUser = partiesForUser?.parties?.some((party) =>
    partyIsTitleCompany(party.role)
  );

  function handleSignOut() {
    signOutFirebase();
    navigate(`/partyLogin`);
  }

  return (
    <>
      <Menu secondary stackable className="main-menu">
        <Menu.Item header style={{ marginLeft: "0px", paddingLeft: "0px" }}>
          <Image src="/assets/logo-color-with-text-small.png" />
        </Menu.Item>
        {authenticated && (
          <>
            {currentUserProfile?.type === "user" && (
              <Menu.Item
                as={NavLink}
                active={location.pathname === "/overview"}
                to={`/overview`}
                name="My Dashboard"
              />
            )}
            <Menu.Item
              as={NavLink}
              active={location.pathname.includes("overviewParty")}
              to={`/overviewParty`}
              name="All Transactions"
            />
            {isTitleCompanyUser && (
              <Menu.Item
                as={NavLink}
                active={location.pathname.includes("dashboardParty")}
                to={`/dashboardParty`}
                name="Dashboard"
              />
            )}
            <Menu.Item position="right">
              <Dropdown
                pointing="top left"
                direction="left"
                text={currentUserProfile?.lastName ? (
                  currentUserProfile?.firstName +
                  " " +
                  currentUserProfile?.lastName
                ) : "Account"
                }
              >
                <Dropdown.Menu>
                  <Dropdown.Item
                    as={Link}
                    to="/partyAccount"
                    text="My account"
                    icon="sun outline"
                  />
                  <Dropdown.Item
                    onClick={handleSignOut}
                    text="Sign Out"
                    icon="power"
                  />
                </Dropdown.Menu>
              </Dropdown>
            </Menu.Item>
          </>
        )}
      </Menu>
    </>
  );
}